module.exports = __webpack_public_path__ + "basic-bottom-bw.svg?ce0da8f06eba08fe230fef35db5632a9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/basic-bottom-bw.svg
// module id = 81
// module chunks = 0